/* eslint-disable react/jsx-no-duplicate-props */
import React, { ReactNode, useEffect, useState } from "react";
import MaskedInput from "react-input-mask";

import colors from "../../constants/color";
import materialUI from "../../material-UI";
import * as Styles from "./styles";

interface Props {
  value?: string;
  onChange: Function;
  onBlur?: () => void;
  type?: "phone" | "date" | "text" | "observacao" | "cep" | "cpf";
  isError?: boolean;
  isDisabled?: boolean;
  placeholder?: string;
  isDisabledPhone?: boolean;
  label?: string;
  color?: string;
  row?: number;
  multiline?: boolean;
  isIconLeft?: boolean;
  icon?: JSX.Element;
  maxLengthProps?: number;
  helperText?: string;
  maskValue?: string;
  idLeadExistente?: string;
  leftIcon?: ReactNode;
}

const useStyles = materialUI.makeStyles({
  root: {
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderWith: "1px",
      borderColor: "#2D5BFF",
    },
    "&.Mui-focused fieldset": {
      borderWith: "1px",
      borderColor: "#2D5BFF !important",
    },
  },
  input: {
    "&::placeholder": {
      textOverflow: "ellipsis !important",
      color: "blue",
    },
  },
});

const TextMaskCPF = (props: any) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      style={{ color: colors.black, fontFamily: "Inter" }}
      {...other}
      ref={inputRef}
      disabled={props?.disabled}
      mask="999.999.999-99"
      showMask
    />
  );
};

const TextMaskCEP = (props: any) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      style={{ color: colors.black, fontFamily: "Inter" }}
      {...other}
      ref={inputRef}
      mask="99999-999"
      showMask={false}
    />
  );
};

const inputCommon: React.FC<Props> = ({
  value,
  onChange,
  onBlur,
  type,
  isDisabled,
  placeholder,
  isDisabledPhone,
  label,
  color,
  row,
  multiline,
  isError,
  maxLengthProps,
  helperText,
  maskValue,
  idLeadExistente,
  leftIcon,
}) => {
  const [leadExistente, setLeadExistente] = useState<boolean>(false);

  useEffect(() => {
    switch (helperText) {
      case "Este lead já consta em sua carteira":
        return setLeadExistente(true);
      case "Este lead já consta na sua carteira":
        return setLeadExistente(true);
      default:
        return setLeadExistente(false);
    }
  }, [helperText]);

  useEffect(() => {
    makeFlagDropDownNotSelectable();
  }, []);

  const makeFlagDropDownNotSelectable = () => {
    const flagDropDownElement =
      document.getElementsByClassName("selected-flag");

    if (flagDropDownElement && flagDropDownElement.length > 0) {
      // @ts-ignore
      flagDropDownElement[0].setAttribute("tabindex", -1);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {type === "phone" ? (
        <>
          <Styles.Label color={isError ? "red" : colors.grey1}>
            {label}
          </Styles.Label>
          <Styles.InputPhone
            onBlur={onBlur}
            disabled={isDisabledPhone}
            dropdownStyle={{ borderRadius: 8 }}
            buttonStyle={{
              border: "none",
              margin: 6,
              backgroundColor: "transparent",
            }}
            value={value}
            onChange={(event, event1, event2, event3) => {
              onChange(event3);
            }}
            inputStyle={{
              borderWidth: 1,
              paddingTop: 3,
              width: "100%",
              height: 41,
              borderColor: isError ? "red" : "#D0D5DD",
            }}
            masks={{ br: maskValue }}
            country="br"
          />
        </>
      ) : null}
      {type === "date" ? (
        <>
          <Styles.Label color={isError ? "red" : colors.grey1}>
            {label}
          </Styles.Label>
          <Styles.Input
            style={{ color: color || "#D0D5DD" }}
            value={value}
            className={useStyles().root}
            variant="outlined"
            size="small"
            autoComplete="off"
            onChange={(
              event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => onChange(event.target.value)}
            type={type}
            InputLabelProps={{ style: { fontSize: 16 } }}
            error={isError || false}
            disabled={isDisabled}
            minRows={row || 1}
            multiline={multiline || false}
          />
        </>
      ) : null}
      {type === "text" && (
        <>
          <Styles.Label color={isError ? "red" : colors.grey1}>
            {label}
          </Styles.Label>
          <Styles.Input
            style={{
              borderWidth: 1,
              borderRadius: 8,
              borderColor: isError ? "red" : "#D0D5DD !important",
            }}
            value={value}
            onBlur={onBlur}
            className={useStyles().root}
            variant="outlined"
            autoComplete="off"
            onChange={(
              event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => onChange(event.target.value)}
            type={type}
            placeholder={placeholder || ""}
            InputLabelProps={{ style: { fontSize: 14 } }}
            error={isError || false}
            disabled={isDisabled}
            minRows={row || 1}
            size="small"
            multiline={multiline || false}
            inputProps={{ maxLength: maxLengthProps || 300 }}
            InputProps={{
              startAdornment: leftIcon ? (
                <materialUI.InputAdornment position="start">
                  {leftIcon}
                </materialUI.InputAdornment>
              ) : null,
            }}
          />
        </>
      )}
      {type === "observacao" && (
        <Styles.InputArea>
          <Styles.Label color={isError ? "red" : colors.grey1}>
            {label}
          </Styles.Label>
          <Styles.CountText>{`${value?.length || "0"}/${
            maxLengthProps || "500"
          }`}</Styles.CountText>
          <Styles.Input
            style={{ color: color || "#fff" }}
            value={value}
            className={useStyles().root}
            variant="outlined"
            autoComplete="off"
            onChange={(
              event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => onChange(event.target.value)}
            type={type}
            placeholder={placeholder || ""}
            InputLabelProps={{ style: { fontSize: 14 } }}
            error={isError || false}
            disabled={isDisabled}
            minRows={row || 1}
            size="small"
            multiline={multiline || false}
            inputProps={{ maxLength: maxLengthProps }}
          />
        </Styles.InputArea>
      )}
      {type === "cpf" && (
        <>
          <Styles.Label color={isError ? "red" : colors.grey1}>
            {label}
          </Styles.Label>
          <Styles.Input
            style={{ color: color || "#ffffff" }}
            value={value}
            className={useStyles().root}
            variant="outlined"
            autoComplete="off"
            size="small"
            onChange={(
              event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => onChange(event.target.value)}
            type={type}
            InputLabelProps={{ style: { fontSize: 14 } }}
            error={isError || false}
            disabled={isDisabled}
            minRows={row || 1}
            multiline={multiline || false}
            label={label}
            InputProps={{
              inputComponent: TextMaskCPF,
            }}
          />
        </>
      )}
      {type === "cep" && (
        <Styles.Input
          style={{ color: color || "#fff" }}
          value={value}
          className={useStyles().root}
          variant="outlined"
          autoComplete="off"
          size="small"
          onChange={(event) => onChange(event.target.value)}
          type={type}
          InputLabelProps={{ style: { fontSize: 14 } }}
          error={isError || false}
          disabled={isDisabled}
          minRows={row || 1}
          multiline={multiline || false}
          label={label}
          InputProps={{
            inputComponent: TextMaskCEP,
          }}
        />
      )}
      {isError && helperText && (
        <Styles.Helper>
          {helperText}
          {leadExistente ? (
            <>
              <a href={`/leads/${idLeadExistente}`}> Visualizar lead</a>
            </>
          ) : (
            <></>
          )}
        </Styles.Helper>
      )}
    </div>
  );
};
export default inputCommon;
